<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <PageHeader :title="title" :items="items" />
                </div>
            </div>
        </div>
        <div class="row" style="margin-bottom: 150px">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
                            <span v-for="(err, index) in validation_errors" :key="index">{{ err[0] }} <br /></span>
                        </div>

                        <form action="">
                            <div class="form-row">
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="ep_types">EP Type <span class="c-required">*</span></label>
                                    <multiselect
                                        ref="ep_types"
                                        v-model="ses.ep_types"
                                        id="ep_types"
                                        name="ep_types"
                                        :multiple="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select ep types"
                                        track-by="id"
                                        :preselect-first="true"
                                        :options="ep_types"
                                        :custom-label="customEpTypes"
                                    ></multiselect>
                                    <div
                                        class="text-danger"
                                        style="margin-top: 0.25rem; font-size: 0.75rem;"
                                        v-if="errors.has('ep_types')"
                                        >Please select an ep type.</div
                                    >
                                </div>
                                <!--                                <div class="col-md-6 col-sm-6 col-lg-4">-->
                                <!--                                    <label for="form_no">Form No. <span class="c-required">*</span></label>-->
                                <!--                                    <input type="number" v-model="ses.form_no" v-validate="'required|length:5'" id="form_no" name="form_no" class="form-control form-control-sm" placeholder="Form number"/>-->
                                <!--                                    <div class="invalid-feedback">-->
                                <!--                                        Please enter form number.-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="rp_serial">RP Serial</label>
                                    <input
                                        type="number"
                                        v-model="ses.rp_serial"
                                        v-validate="'numeric'"
                                        id="rp_serial"
                                        name="rp_serial"
                                        class="form-control form-control-sm"
                                        placeholder="RP serial"
                                    />
                                    <div class="invalid-feedback">RP serial is required</div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="mobile">Mobile No. <span class="c-required">*</span></label>
                                    <input
                                        type="number"
                                        v-model="ses.mobile"
                                        v-validate="'required|length:11'"
                                        id="mobile"
                                        name="mobile"
                                        class="form-control form-control-sm"
                                        placeholder="Mobile number"
                                    />
                                    <div class="invalid-feedback">
                                        Please enter mobile number.
                                    </div>
                                </div>
                            </div>
                            <div class="form-row mt-2">
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="nid" class="col-form-label col-form-label-sm">
                                        <span v-if="ses.id_type === 'N'"
                                            >National ID <span class="c-required">*</span></span
                                        >
                                        <span v-if="ses.id_type === 'P'"
                                            >Passport No. <span class="c-required">*</span></span
                                        >
                                        <span v-if="ses.id_type === 'B'"
                                            >Birth Certificate No. <span class="c-required">*</span></span
                                        >
                                    </label>
                                    <div class="row m-0">
                                        <div class="col-3 p-0">
                                            <select class="form-control form-control-sm" v-model="ses.id_type">
                                                <option value="N">NID</option>
                                                <option value="P">Passport</option>
                                                <option value="B">Birth</option>
                                            </select>
                                        </div>
                                        <div class="col-9 p-0">
                                            <input
                                                type="text"
                                                v-model="ses.nid"
                                                v-validate="{ required: true, regex: /^[a-zA-Z0-9_.-]*$/, min: 6 }"
                                                id="nid"
                                                name="nid"
                                                class="form-control form-control-sm"
                                                placeholder="Enter NID/Birth/Passport number"
                                            />
                                        </div>
                                        <div class="invalid-feedback">
                                            Please enter a valid number.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="household_number">Household No.</label>
                                    <input
                                        type="number"
                                        v-model="ses.household_number"
                                        id="household_number"
                                        name="household_number"
                                        class=" form-control form-control-sm"
                                        placeholder="Household number"
                                    />
                                    <div class="invalid-feedback">
                                        Please enter household number.
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="name"
                                        >1.1 Name of Household Head <span class="c-required">*</span></label
                                    >
                                    <input
                                        type="text"
                                        v-model="ses.name"
                                        v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }"
                                        id="name"
                                        name="name"
                                        class=" form-control form-control-sm"
                                        placeholder="Household head name"
                                    />
                                    <div class="invalid-feedback">
                                        Please enter household head name.
                                    </div>
                                </div>
                            </div>
                            <div class="form-row mt-2">
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="father_hus_type">
                                        <span v-if="ses.father_hus_type === 'F'"
                                            >1.2 Father Name <span class="c-required">*</span></span
                                        >
                                        <span v-if="ses.father_hus_type === 'H'"
                                            >1.2 Husband Name <span class="c-required">*</span></span
                                        >
                                        <span v-if="ses.father_hus_type === 'S'"
                                            >1.2 Spouse Name. <span class="c-required">*</span></span
                                        >
                                    </label>
                                    <div class="row m-0">
                                        <div class="col-3 p-0">
                                            <select
                                                class="form-control form-control-sm"
                                                v-model="ses.father_hus_type"
                                                id="father_hus_type"
                                                name="father_or_husband"
                                                v-validate="{ required: true }"
                                            >
                                                <option value="F">Father</option>
                                                <option value="H">Husband</option>
                                                <option value="S">Spouse</option>
                                            </select>
                                        </div>
                                        <div class="col-9 p-0">
                                            <input
                                                type="text"
                                                v-model="ses.father_husband_name"
                                                v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }"
                                                id="father_husband_name"
                                                name="father_husband_name"
                                                class=" form-control form-control-sm"
                                                placeholder="Father/Husband name"
                                            />
                                            <div class="invalid-feedback">Please enter Father/Husband name.</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="mother_name">1.3 Mother Name <span class="c-required">*</span></label>
                                    <input
                                        type="text"
                                        v-model="ses.mother_name"
                                        v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }"
                                        id="mother_name"
                                        name="mother_name"
                                        class=" form-control form-control-sm"
                                        placeholder="Mother's name"
                                    />
                                    <div class="invalid-feedback">Please enter Mother's name.</div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="dob">1.4 Date of Birth <span class="c-required">*</span></label>
                                    <datepicker
                                        v-model="ses.dob"
                                        v-validate="'required'"
                                        id="dob"
                                        name="dob"
                                        :format="customDateDob"
                                        :disabled-dates="disabledDates"
                                        placeholder="Date of Birth"
                                    ></datepicker>
                                    <div
                                        class="text-danger"
                                        style="margin-top: 0.25rem; font-size: 0.75rem;"
                                        v-if="errors.has('dob')"
                                        >Date of birth is required</div
                                    >
                                </div>
                            </div>
                            <div class="form-row mt-2">
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="gender_id">Gender <span class="c-required">*</span></label>
                                    <select
                                        v-model="ses.gender_id"
                                        v-validate="'required'"
                                        id="gender_id"
                                        name="gender_id"
                                        class="form-control form-control-sm"
                                    >
                                        <option selected disabled :value="''">Select Gender</option>
                                        <option v-for="(gender, index) in genders" :key="index" :value="gender.id"
                                            >{{ gender.id }} : {{ gender.gender_desc }}</option
                                        >
                                    </select>
                                    <div class="invalid-feedback">
                                        Please select a gender.
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="village_id">1.5 Village <span class="c-required">*</span></label>
                                    <select
                                        v-model="ses.village_id"
                                        v-validate="'required'"
                                        id="village_id"
                                        name="village_id"
                                        @change="getAddress(ses.village_id)"
                                        class="form-control form-control-sm"
                                    >
                                        <option selected disabled :value="''">Select a village</option>
                                        <option v-for="(village, index) in villages" :key="index" :value="village.id"
                                            >{{ village.id }} : {{ village.village_desc }}</option
                                        >
                                    </select>
                                    <div class="invalid-feedback">Please select Village.</div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="mouza_id">1.6 Mouza <span class="c-required">*</span></label>
                                    <select
                                        v-model="ses.mouza_id"
                                        v-validate="'required'"
                                        id="mouza_id"
                                        name="mouza_id"
                                        class="custom-select custom-select-sm"
                                        disabled
                                    >
                                        <option selected disabled :value="''">Select a mouza</option>
                                        <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id"
                                            >{{ mouza.id }} : {{ mouza.mouza_desc }}</option
                                        >
                                    </select>
                                    <div class="invalid-feedback">Please select Mouza.</div>
                                </div>
                            </div>
                            <div class="form-row mt-2">
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="union_id">1.7 Union <span class="c-required">*</span></label>
                                    <select
                                        v-model="ses.union_id"
                                        v-validate="'required'"
                                        id="union_id"
                                        name="union_id"
                                        disabled
                                        class="custom-select custom-select-sm"
                                    >
                                        <option selected disabled :value="''">Select a union</option>
                                        <option v-for="(union, index) in unions" :key="index" :value="union.id"
                                            >{{ union.id }} : {{ union.union_desc }}</option
                                        >
                                    </select>
                                    <div class="invalid-feedback">Please select Union.</div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="upazila_id">1.8 Upazila <span class="c-required">*</span></label>
                                    <select
                                        v-model="ses.upazila_id"
                                        v-validate="'required'"
                                        id="upazila_id"
                                        name="upazila_id"
                                        disabled
                                        class="custom-select custom-select-sm"
                                    >
                                        <option selected disabled :value="''">Select a upazila</option>
                                        <option v-for="(upazilla, index) in upazillas" :key="index" :value="upazilla.id"
                                            >{{ upazilla.id }} : {{ upazilla.upazila_desc }}</option
                                        >
                                    </select>
                                    <div class="invalid-feedback">Please select upazila.</div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="district_id">1.9 District <span class="c-required">*</span></label>
                                    <select
                                        v-model="ses.district_id"
                                        v-validate="'required'"
                                        id="district_id"
                                        name="district_id"
                                        disabled
                                        class="custom-select custom-select-sm"
                                    >
                                        <option selected disabled :value="''">Select a district</option>
                                        <option v-for="(district, index) in districts" :key="index" :value="district.id"
                                            >{{ district.id }} : {{ district.district_desc }}</option
                                        >
                                    </select>
                                    <div class="invalid-feedback">Please select district.</div>
                                </div>
                            </div>
                            <div class="form-row mt-2">
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="occupation_id"
                                        >1.10 Main Occupation <span class="c-required">*</span></label
                                    >
                                    <select
                                        v-model="ses.occupation_id"
                                        v-validate="'required'"
                                        id="occupation_id"
                                        name="occupation_id"
                                        class="form-control form-control-sm"
                                    >
                                        <option selected disabled :value="''">Select an occupation</option>
                                        <option
                                            v-for="(occupation, index) in occupations"
                                            :key="index"
                                            :value="occupation.id"
                                            >{{ occupation.id }} : {{ occupation.occupation_desc }}</option
                                        >
                                    </select>
                                    <div class="invalid-feedback">Please select occupation.</div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="religion_id">1.11 Religion <span class="c-required">*</span></label>
                                    <select
                                        v-model="ses.religion_id"
                                        v-validate="'required'"
                                        id="religion_id"
                                        name="religion_id"
                                        class="form-control form-control-sm"
                                    >
                                        <option selected disabled :value="''">Select a Religion</option>
                                        <option v-for="(religion, index) in religions" :key="index" :value="religion.id"
                                            >{{ religion.id }} : {{ religion.religion_desc }}</option
                                        >
                                    </select>
                                    <div class="invalid-feedback">Please select a religion.</div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="ethnic"
                                        >1.12 Ethnic(Mention the Group) <span class="c-required">*</span></label
                                    >
                                    <input
                                        type="text"
                                        v-model="ses.ethnic"
                                        v-validate="'required'"
                                        id="ethnic"
                                        name="ethnic"
                                        class="form-control form-control-sm"
                                        placeholder="Enter ethnic(mention the group)"
                                    />
                                    <div class="invalid-feedback">
                                        Please enter ethnic name.
                                    </div>
                                </div>
                            </div>
                            <div class="form-row mt-2">
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="yearly_income"
                                        >1.13 Yearly income of the Household/Institution.
                                        <span class="c-required">*</span></label
                                    >
                                    <input
                                        type="number"
                                        v-model="ses.yearly_income"
                                        v-validate="'required|numeric'"
                                        id="yearly_income"
                                        name="yearly_income"
                                        class="form-control form-control-sm"
                                        placeholder="Enter yearly income in number"
                                    />
                                    <div class="invalid-feedback">
                                        Please enter yearly income
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="yearly_exp"
                                        >1.14 Yearly expense of the household/Institution
                                        <span class="c-required">*</span></label
                                    >
                                    <input
                                        type="number"
                                        v-model="ses.yearly_exp"
                                        v-validate="'required|numeric'"
                                        id="yearly_exp"
                                        name="yearly_exp"
                                        class="form-control form-control-sm"
                                        placeholder="Enter expenditure income in number"
                                    />
                                    <div class="invalid-feedback">
                                        Please enter yearly expenditure.
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="institution_sec"
                                        >1.15 Name of Social Institution's Owner/ President/Secretary</label
                                    >
                                    <input
                                        type="text"
                                        v-model="ses.institution_sec"
                                        id="institution_sec"
                                        name="institution_sec"
                                        class="form-control form-control-sm"
                                        placeholder="Enter name of social institution's Owner/ President/Secretary"
                                    />
                                    <div class="invalid-feedback">
                                        Please enter Social Institution Owner/ President/Secretary name
                                    </div>
                                </div>
                            </div>
                            <div class="form-row mt-2">
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="is_household_head"
                                        >1.6 is Household Head <span class="c-required">*</span></label
                                    >
                                    <select
                                        v-model="ses.is_household_head"
                                        v-validate="'required'"
                                        id="is_household_head"
                                        name="is_household_head"
                                        class="form-control form-control-sm"
                                    >
                                        <option selected value="1">Yes</option>
                                        <option value="0">No</option>
                                    </select>
                                    <div class="invalid-feedback">Please select a option</div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="is_disable">1.7 is Disable <span class="c-required">*</span></label>
                                    <select
                                        v-model="ses.is_disable"
                                        v-validate="'required'"
                                        id="is_disable"
                                        name="is_disable"
                                        class="form-control form-control-sm"
                                    >
                                        <option selected value="0">No</option>
                                        <option value="1">Yes</option>
                                    </select>
                                    <div class="invalid-feedback">Please select a option</div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="is_disable">1.18 10% Land loss</label>
                                    <select
                                        v-model="ses.is_land_loss"
                                        v-validate="'required'"
                                        id="land_loss"
                                        name="land_loss"
                                        class="form-control form-control-sm"
                                    >
                                        <option selected value="0">No</option>
                                        <option value="1">Yes</option>
                                    </select>
                                    <div class="invalid-feedback">Please select a option</div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4 mt-1">
                                    <label for="is_disable">1.19 10% Income loss</label>
                                    <select
                                        v-model="ses.is_income_loss"
                                        v-validate="'required'"
                                        id="income_loss"
                                        name="income_loss"
                                        class="form-control form-control-sm"
                                    >
                                        <option selected value="0">No</option>
                                        <option value="1">Yes</option>
                                    </select>
                                    <div class="invalid-feedback">Please select a option</div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4 mt-1">
                                    <label for="appointment_by">Appointment By</label>
                                    <input
                                        type="text"
                                        v-model="ses.appointment_by"
                                        id="appointment_by"
                                        name="appointment_by"
                                        class="form-control form-control-sm"
                                        placeholder="Appointment by"
                                    />
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4 mt-1">
                                    <label for="appointment_date">Appointment Date</label>
                                    <datepicker
                                        v-model="ses.appointment_date"
                                        id="appointment_date"
                                        name="appointment_date"
                                        :format="customDateAppointment"
                                        placeholder="Appointment Date"
                                    ></datepicker>
                                </div>
                            </div>
                            <div class="form-row mt-2">
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="area_manager_id">Area Manager</label>
                                    <select
                                        v-model="ses.area_manager_id"
                                        v-validate="'required'"
                                        id="area_manager_id"
                                        name="area_manager_id"
                                        class="form-control form-control-sm"
                                        @change="getSurveyConducted()"
                                    >
                                        <option selected disabled :value="''">Select Area Manager</option>
                                        <option
                                            v-for="(area_manager, index) in area_managers"
                                            :key="index"
                                            :value="area_manager.id"
                                            >{{ area_manager.id }} : {{ area_manager.name }}</option
                                        >
                                    </select>
                                    <div class="invalid-feedback">Please select area manager.</div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="area_manager_date">Area Manager Date</label>
                                    <datepicker
                                        v-model="ses.area_manager_date"
                                        v-validate="'required'"
                                        id="area_manager_date"
                                        name="area_manager_date"
                                        :format="customDateAreaManager"
                                        placeholder="Area Manager Date"
                                    ></datepicker>
                                    <div
                                        class="text-danger"
                                        v-if="errors.has('area_manager_date')"
                                        style="margin-top: 0.25rem; font-size: 0.75rem;"
                                        >Area manager date required</div
                                    >
                                </div>

                                <div class="col-md-6 col-sm-6 col-lg-4">
                                    <label for="survey_worker_id"
                                        >Survey Conducted By<span class="c-required">*</span></label
                                    >
                                    <select
                                        v-model="ses.survey_worker_id"
                                        v-validate="'required'"
                                        :disabled="ses.area_manager_id.length === 0"
                                        id="survey_worker_id"
                                        name="survey_worker_id"
                                        class="form-control form-control-sm"
                                    >
                                        <option selected disabled :value="''">Select Worker who conduct Survey</option>
                                        <option
                                            v-for="(survey_worker, index) in survey_workers"
                                            :key="index"
                                            :value="survey_worker.id"
                                            >{{ survey_worker.id }} : {{ survey_worker.name }}</option
                                        >
                                    </select>
                                    <div class="invalid-feedback">
                                        Please select Worker.
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-4 mt-1">
                                    <label for="survey_date"
                                        >Survey Conducted Date<span class="c-required">*</span></label
                                    >
                                    <datepicker
                                        v-model="ses.survey_date"
                                        v-validate="'required'"
                                        id="survey_date"
                                        name="survey_date"
                                        :format="customDateSurvey"
                                        placeholder="Survey Date"
                                    ></datepicker>
                                    <div
                                        class="text-danger"
                                        v-if="errors.has('survey_date')"
                                        style="margin-top: 0.25rem; font-size: 0.75rem;"
                                        >Survey date required</div
                                    >
                                </div>
                            </div>

                            <div class="form-row mt-4">
                                <div class="col">
                                    <button
                                        v-if="userPermission.includes('ses-create')"
                                        class="btn btn-danger waves-effect waves-light mr-2"
                                        @click.prevent="save(1)"
                                    >
                                        Save and Exit
                                    </button>

                                    <!-- v-if="userPermission.includes('ses-create')" -->
                                    <button
                                        class="btn btn-success waves-effect waves-light mr-2"
                                        @click.prevent="save(2)"
                                    >
                                        Save and Continue
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import Multiselect from 'vue-multiselect'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import http from '@state/http'

export default {
    page: {
        title: 'Socio Economic Survey(SES)',
        meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, PageHeader, Datepicker, Multiselect },
    data() {
        return {
            title: 'Socio Economic Survey(SES)',
            items: [
                {
                    text: 'Dashboard',
                    href: '/',
                },
                {
                    text: 'SES',
                    active: true,
                },
            ],
            validation_errors: {},
            show: false,
            ep_types: [],
            genders: [],
            villages: [],
            mouzas: [],
            unions: [],
            upazillas: [],
            districts: [],
            divisions: [],
            religions: [],
            occupations: [],
            educations: [],
            survey_workers: [],
            area_managers: [],
            ses: {
                ep_types: [],
                // form_no: "",
                mobile: '',
                id_type: 'N',
                nid: '',
                father_hus_type: 'F',
                household_number: '',
                name: '',
                father_husband_name: '',
                mother_name: '',
                dob: null,
                gender_id: '',
                village_id: '',
                mouza_id: '',
                union_id: '',
                upazila_id: '',
                district_id: '',
                division_id: '',
                occupation_id: '',
                religion_id: 1,
                ethnic: 'N/A',
                rp_serial: '',
                yearly_income: '',
                yearly_exp: '',
                institution_sec: '',
                is_household_head: '',
                is_disable: '',
                appointment_by: '',
                survey_worker_id: '',
                area_manager_id: '',
                appointment_date: '',
                survey_date: '',
                area_manager_date: '',
                is_land_loss: '',
                is_income_loss: '',
            },
            checkedData: true,
            disabledDates: {
                from: new Date(Date.now()),
            },
        }
    },

    mounted() {
        this.getCodes()
    },

    methods: {
        customEpTypes(option) {
            return `${option.id} - ${option.ep_type_desc}`
        },
        customDateDob(date) {
            this.ses.dob = moment(date).format('YYYY-MM-DD')
            return moment(date).format('YYYY-MM-DD')
        },
        customDateSurvey(date) {
            this.ses.survey_date = moment(date).format('YYYY-MM-DD')
            return moment(date).format('YYYY-MM-DD')
        },
        customDateAreaManager(date) {
            this.ses.area_manager_date = moment(date).format('YYYY-MM-DD')
            return moment(date).format('YYYY-MM-DD')
        },
        customDateAppointment(date) {
            this.ses.appointment_date = moment(date).format('YYYY-MM-DD')
            return moment(date).format('YYYY-MM-DD')
        },
        save(exitType) {
            this.$validator.validate().then((valid) => {
                if (valid) {
                    http.post('api/seses', this.ses)
                        .then((response) => {
                            if (response.data.error === true) {
                                this.$bvToast.toast(response.data.message, {
                                    title: 'Error',
                                    autoHideDelay: 5000,
                                    variant: 'danger',
                                })
                            }

                            if (!response.data.error) {
                                if (exitType === 1) {
                                    // this.$router.push("/ses/view/" + response.data.created_id);
                                    this.$router.push('/ses/view/' + response.data.created_id, () => {
                                        this.$toasted.show(response.data.message, {
                                            theme: 'toasted-primary',
                                            position: 'top-right',
                                            duration: 60000,
                                            type: 'success',
                                            action: {
                                                text: 'Ok',
                                                onClick: (e, toastObject) => {
                                                    toastObject.goAway(0)
                                                },
                                            },
                                        })
                                    })
                                }
                                if (exitType === 2) {
                                    // this.$router.push("/ses/create/step-two/" + response.data.created_id);
                                    this.$router.push('/ses/create/step-two/' + response.data.created_id, () => {
                                        this.$toasted.show(response.data.message, {
                                            theme: 'toasted-primary',
                                            position: 'top-right',
                                            duration: 60000,
                                            type: 'success',
                                            action: {
                                                text: 'Cancel',
                                                onClick: (e, toastObject) => {
                                                    toastObject.goAway(0)
                                                },
                                            },
                                        })
                                    })
                                }
                            }
                        })
                        .catch((error) => {
                            this.validation_errors = error.response.data.errors
                            this.show = true
                            this.hide()
                        })
                }
            })
        },
        getCodes() {
            http.get('api/ses/codes').then((response) => {
                if (!response.error) {
                    let data = response.data
                    this.ep_types = data.ep_types
                    this.genders = data.genders
                    this.villages = data.villages
                    this.unions = data.unions
                    this.districts = data.districts
                    this.upazillas = data.upazillas
                    this.religions = data.religions
                    this.occupations = data.occupations
                    this.mouzas = data.mouzas
                    this.divisions = data.divisions
                    // this.survey_workers = data.survey_workers;
                    this.area_managers = data.area_managers
                }
            })
        },
        getAddress(village_id) {
            let village = this.villages.find((v) => v.id == village_id)

            let mouza = this.mouzas.find((m) => m.id == village.mouza_id)
            this.ses.mouza_id = mouza.id

            let union = this.unions.find((u) => u.id == mouza.union_id)
            this.ses.union_id = union.id

            let upazila = this.upazillas.find((d) => d.id == union.upazila_id)
            this.ses.upazila_id = upazila.id

            let district = this.districts.find((d) => d.id == upazila.district_id)
            this.ses.district_id = district.id

            let division = this.divisions.find((dv) => dv.id == district.division_id)
            this.ses.division_id = division.id
        },
        getSurveyConducted() {
            this.survey_workers = this.area_managers.find(
                (area_manager) => area_manager.id == this.ses.area_manager_id
            ).survey_workers
        },
        toast($message, $title, $variant) {
            this.$bvToast.toast($message, {
                title: $title,
                noAutoHide: true,
                variant: $variant,
            })
        },
        hide() {
            setTimeout(() => {
                this.show = false
            }, 5000)
        },
    },
    computed: {
        userPermission() {
            return this.$store.state.user
        },
    },
    created() {
        this.$store.dispatch('getUserPermission')
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.custom-select {
    -webkit-appearance: unset;
}
.vdp-datepicker input {
    width: 100%;
    border-radius: 3px;
    border: 1px solid #ced4da;
    height: 30px;
    padding-left: 15px;
    color: #6b757d;
}
.multiselect__tags {
    border-color: #ced4da;
    border-radius: 3px;
    min-height: 31px;
    padding: 4px 25px 0px 10px;
    margin-bottom: 0;
}
.multiselect__tag {
    margin-bottom: 0px;
}
.multiselect__placeholder {
    margin-bottom: 0px;
}
.multiselect__select {
    height: 31px;
}
.custom-select {
    color: #6c757d !important;
}
.c-required {
    color: red;
}
</style>
